import { connect } from "react-redux";
// Component
import AdminList from "components/AdminList";
// API
import api from "api";
// Action
import { openErrorDialog } from "redux/modules/errorDialog";

import {
  setAdminList,
  changeSearchForm,
  openAdminModal
} from "redux/modules/adminList";
// Utils
import history from "utils/history";

const mapStateToProps = state => ({
  adminList: state.adminList
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  historyPush: path => history.push(path, ownProps),
  fetchAdminList: search => {
    const params = { search };
    api
      .get("admins", params)
      .then(res => {
        dispatch(setAdminList(res.admins));
      })
      .catch(error => dispatch(openErrorDialog(error)));
  },
  changeSearchForm: (key, value) => {
    dispatch(changeSearchForm(key, value));
  },
  openAdminModal: id => () => {
    // 新規もしくは更新
    const path = id === null ? "admins/new" : `admins/${id}/edit`;

    api
      .get(path)
      .then(res => {
        dispatch(openAdminModal(res.admin));
      })
      .catch(error => {
        dispatch(openErrorDialog(error));
      });
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminList);



// WEBPACK FOOTER //
// ./src/containers/AdminList/AdminListContainer.js